import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { redirectToRestrictedUrl } from '../../actions/helpers/redirect';
import { setPopover } from '../../actions/login';
import { TYPO3_URL } from '../../config';
import theme from '../../constants/theme';

const AccountMenuLink = ({ dispatch, href, children }) => {
  const language = window.location.pathname.split('/')[1];
  const url = `${TYPO3_URL}/${language}${href}`;
  return (
    <li
      css={css`
        list-style: none;
      `}
    >
      <a
        css={css`
          display: block;
          padding: 4px;
          color: ${theme.colors.black};
          line-height: 1.6;
          transition: all 0.15s ease-in-out;

          &:hover,
          &:focus,
          &:active {
            text-decoration: none;
          }

          &:hover {
            background-color: ${theme.colors.primaryBlue};
            color: ${theme.colors.pureWhite};
          }
        `}
        href={url}
        onClick={(event) => {
          event.preventDefault();
          dispatch(setPopover(false));
          dispatch(redirectToRestrictedUrl(url));
        }}
      >
        {children}
      </a>
    </li>
  );
};

AccountMenuLink.propTypes = {
  dispatch: PropTypes.func.isRequired,
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default connect()(AccountMenuLink);
